<template>
  <div id="app">
    <v-app>

      <v-navigation-drawer
        v-model="drawer"
        absolute
        style="position:fixed; top:0; left:0; overflow-y:scroll;"
        temporary>
        <v-list nav dense>

        
          <v-list-item href="./research">
            <v-list-item-icon>
              <v-icon>mdi-feature-search-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Research</v-list-item-title>
          </v-list-item>

          <v-list-item href="./#cv">
            <v-list-item-icon>
              <v-icon>mdi-file-account</v-icon>
            </v-list-item-icon>
            
            <v-list-item-title>CV</v-list-item-title>
            
          </v-list-item>

          <v-list-item href="./projects">
            <v-list-item-icon>
              <v-icon>mdi-tools</v-icon>
            </v-list-item-icon>
            
            <v-list-item-title>Projects</v-list-item-title>
            
          </v-list-item>

          <v-list-item href="./interests">
            <v-list-item-icon>
              <v-icon>mdi-heart</v-icon>
            </v-list-item-icon>
            
            <v-list-item-title>Interests</v-list-item-title>
            
          </v-list-item>


        </v-list>
      </v-navigation-drawer>

      <v-app-bar 
        app
        color="#4C6665"
        height="100"
        inverted-scroll
        scroll-threshold='5'
        clipped-right
        elevation="0">
        <a href = './'><v-avatar

          class="mr-3"
          color="#4C6665"
          size="70"
        >
          <v-img
            contain
            max-height="70%"
            src="@/assets/logo.png"
          ></v-img>
        </v-avatar></a>
        
        <v-spacer></v-spacer>

        <v-btn title="Research" href='./research' v-if="$vuetify.breakpoint.mdOnly||$vuetify.breakpoint.lgOnly||$vuetify.breakpoint.xlOnly" icon style="color:white">
          <v-icon large>mdi-feature-search-outline</v-icon>
        </v-btn>
        <v-btn title="CV" @click="$vuetify.goTo('#cv')" v-if="$vuetify.breakpoint.mdOnly||$vuetify.breakpoint.lgOnly||$vuetify.breakpoint.xlOnly" icon style="color:white">
          <v-icon large>mdi-file-account</v-icon>
        </v-btn>
        <v-btn title="Projects" href='./projects' v-if="$vuetify.breakpoint.mdOnly||$vuetify.breakpoint.lgOnly||$vuetify.breakpoint.xlOnly" icon style="color:white">
          <v-icon large>mdi-tools</v-icon>
        </v-btn>
        <v-btn title="Interests" href="./interests" v-if="$vuetify.breakpoint.mdOnly||$vuetify.breakpoint.lgOnly||$vuetify.breakpoint.xlOnly" icon style="color:white">
          <v-icon large>mdi-heart</v-icon>
        </v-btn>
        <v-btn v-if="$vuetify.breakpoint.smOnly||$vuetify.breakpoint.xsOnly" icon style="color:white" @click="drawer = !drawer">
          <v-icon large>mdi-menu</v-icon>
        </v-btn>
        

      </v-app-bar>

      <v-content>
        <section id="hero">
          <v-row no-gutters>
            <div
              class="color"
              
            >
              <v-theme-provider dark>
                <v-container fill-height>
                  <v-row
                    align="center"
                    class="white--text mx-auto"
                    justify="center"
                  >
                    <v-col
                      class="white--text text-start"
                      cols="12"
                      tag="h1"
                    >
                      <span
                        class="font-weight-light"
                        :class="[$vuetify.breakpoint.smAndDown ? 'display-1' : 'display-2']"
                      >
                        Hi, my name is Santiago Mille and I
                      </span>

                      <br>

                      <span
                        :class="[$vuetify.breakpoint.smAndDown ? 'display-1 '+color: 'display-2 '+color]"
                        class="font-weight-black"
                      >
                        {{text}}
                      </span>

                    </v-col>
                    <v-col class="padding-top align-self-end">
                      <v-btn target="_blank" href="https://www.linkedin.com/in/luissantiagomille/" icon style="color:white">
                        <v-icon >mdi-linkedin</v-icon>
                      </v-btn>
                      <v-btn icon target='_blank' href='https://twitter.com/santimillef' style="color:white">
                        <v-icon >mdi-twitter</v-icon>
                      </v-btn>
                      <v-btn icon target='_blank' href='https://instagram.com/santiagomille' style="color:white">
                        <v-icon >mdi-instagram</v-icon>
                      </v-btn>
                      <v-btn icon target='_blank' href='https://github.com/SantiagoMille' style="color:white">
                        <v-icon >mdi-github</v-icon>
                      </v-btn>
                      <v-btn icon target='_blank' href='mailto:santiago.mille96@gmail.com' style="color:white">
                        <v-icon >mdi-email</v-icon>
                      </v-btn>
                    </v-col>

                  </v-row>
                </v-container>
              </v-theme-provider>
            </div>
          </v-row>
        </section>

        <section style="background:#dedede" id="about-me">
          <div class="py-12"></div>

          <v-container  class="text-center less-margin">
            <h2 class="display-2 black-text font-weight-bold mb-3">ABOUT ME</h2>

            <v-responsive class="mx-auto mb-8" width="56">
              <v-divider class="mb-1"></v-divider>
              <v-divider></v-divider>
            </v-responsive>

            <v-row class='margin-about'>
              <v-col cols="12" md="4">
                <v-img class="img" 
                contain src="../../assets/mille.jpg"/>
              </v-col>
              <v-col class="black-text" cols="12" md="8">
                <h3 class='aboutMe_intro'>Scientist and engineer from México City working in AI for molecular design.</h3>
                <h4 class='aboutMe' id='cv'>
                  <br>
                  I’m a Bioengineering PhD candidate at Stanford in Prof. Xiaojing <a rel="noopener noreferrer" class="link" target="_blank" href="https://gaolab.blog/">Gao's Lab</a> 
                  and a graduate researcher with the <a rel="noopener noreferrer" class="link" target="_blank" href="https://evodesign.org">Hie Lab</a> at the Arc Institute.
                  I work at the intersection of computational biology, protein engineering, and synthetic biology. My work spans computational protein design (including generative design 
                  and test-time steering for protein engineering) and the development of protein- and RNA-based molecular sensors 
                  for therapeutic applications.<br> I am also a <i>Emerson Collective Scholar, Stanford Bio-X Fellow, SIGF Fellow, Stanford Graduate Fellow, and ChEM-H CBI Trainee</i>.<br><br>

                  I previously trained at the Mexican Institute of Genomic Medicine (INMEGEN) and in Prof. Shrike <a rel="noopener noreferrer" class="link" target='_blank' href='https://shrikezhang.com'>Zhang Laboratory</a> at Brigham and Women's Hospital / Harvard Medical School.
                  I earned my B.S. in Electrical Engineering from Tecnológico de Monterrey (cum laude). I’m also a co-founder of <a rel="noopener noreferrer" class="link" target='_blank' href='https://sb.stanford.edu'>Stanford Synthetic Biology</a>
                  and <a rel="noopener noreferrer" class="link" target='_blank' href='https://unmotivomas.org'>Un Motivo Mas A.C.</a><br><br>
              
                </h4>
              </v-col>
              
            </v-row>

            <v-row class='margin black-text cv' >
              <v-col cols="12">
                <h3 class="download-resume"><a class="download-resume" href='./CV.pdf' target='_blank'>Download CV</a></h3>                
              </v-col>
            </v-row>

            <div>
              <v-divider/>
            </div>

            <v-row class='margin black-text cv'>
              <v-col cols="12" sm='2'>
                <h2 class="titlee"> Education</h2>                
              </v-col>
              <v-col class="cv-text middle" cols="12" sm="8">   
                <h3 class='semi-title '>Ph.D. in Bioengineering</h3> Stanford University - Advisor: Xiaojing Gao, Ph.D.
              </v-col> 
              <v-col cols="12" sm="2" class="cv-text">
                <h3 class='semi-title'></h3>
              </v-col>
              <v-col cols="12" sm='2'>
                <h2 class="titlee"></h2>                
              </v-col>
              <v-col class="cv-text middle" cols="12" sm="8">   
                <h3 class='semi-title '>B.S. in Electrical Engineering</h3>Minor in Robotics &bull; Monterrey Institute of Technology, Mexico &bull; GPA: 3.87 &bull; Cum Laude
              </v-col> 
              <v-col cols="12" sm="2" class="cv-text">
                <h3 class='semi-title'></h3>
              </v-col>              
            </v-row>

            <div>
              <v-divider/>
            </div>

            <!-- RESEARCH -->
            <v-row class='margin black-text cv' >
              <v-col cols="12" sm='2'>
                <a class="link_title" href="./research"><h2 class="titlee">Research<v-icon>mdi-link-variant</v-icon></h2></a>               
              </v-col>
              <v-col class="cv-text middle" cols="12" sm="10">   
                <h3 class='semi-title '>Hie Lab, Arc Institute &mdash; Graduate Researcher</h3>
                <i>Jul 2024 &ndash; Current, Stanford, CA</i>
                <ul style="background:#dedede">
                  <li>
                    <p class="no-margin">Developed <a rel="noopener noreferrer" class="link" target="_blank" href="https://github.com/SantiagoMille/germinal">Germinal</a>, a first-in-class multi-objective generative antibody design pipeline combining AlphaFold-Multimer structure guidance with IgLM sequence modeling, achieving state-of-the-art in silico design performance.</p>
                  </li>
                  <li>
                    <p class="no-margin">Led experimental validation across multiple antigen targets, demonstrating 4&ndash;22% nanobody hit rates and up to 48% scFv success; developed a novel design screening assay and performed protein purification and binding characterization.</p>
                  </li>
                </ul>
              </v-col> 
            </v-row>

            <v-row class='margin black-text cv' >
              <v-col cols="12" sm='2'>
                <h2 class="titlee"></h2>                
              </v-col>
              <v-col class="cv-text middle" cols="12" sm="10">   
                <h3 class='semi-title '>Gao Lab, Stanford University &mdash; Graduate Student</h3>
                <i>Jun 2022 &ndash; Current, Stanford, CA</i>
                <ul style="background:#dedede">
                  <li>
                    <p class="no-margin">Developed computational methods for efficient, guided protein design, including ProVADA, a test-time steering framework for protein variant engineering via annealed fitness-score optimization.</p>
                  </li>
                  <li>
                    <p class="no-margin">Developing protein- and RNA-based molecular sensors for therapeutic applications. Created a first-in-class, mRNA compatible cell surface synthetic receptor platform for extracellular biomolecular sensing. Publication in Nature Chemical Biology and pending patent.</p>
                  </li>
                </ul>
              </v-col> 
            </v-row>

            <v-row class='margin black-text cv' >
              <v-col cols="12" sm='2'>
                <h2 class="titlee"></h2>                
              </v-col>
              <v-col class="cv-text middle" cols="12" sm="10">   
                <h3 class='semi-title '>Rangel Lab, Mexican Institute of Genomic Medicine &mdash; Research Assistant</h3>
                <i>Aug 2020 &ndash; Jun 2021, Mexico City</i>
                <ul style="background:#dedede">
                  <li>
                    <p class="no-margin">Conducted bioinformatic analyses for the de novo sequencing and annotation of the Leishmania Mexicana parasite, utilizing STAR, Bowtie2, DESeq2, Trinity and custom Python scripts.</p>
                  </li>
                  <li>
                    <p class="no-margin">Analyzed RNASeq data to identify SNPs, copy number variants, and differential gene expression across various phenotypes in human samples.</p>
                  </li>
                </ul>
              </v-col> 
            </v-row>

            <v-row class='margin black-text cv' >
              <v-col cols="12" sm='2'>
                <h2 class="titlee"></h2>                
              </v-col>
              <v-col class="cv-text middle" cols="12" sm="10">   
                <h3 class='semi-title '>Zhang Lab, Brigham and Women's Hospital &mdash; Research Assistant</h3>
                <i>Jun 2019 &ndash; Jul 2020, Boston, MA</i>
                <ul style="background:#dedede">
                  <li>
                    <p class="no-margin">Designed and developed hardware and software to build and automate DLP and extrusion bioprinters.</p>
                  </li>
                  <li>
                    <p class="no-margin">Printed cell-laden, hydrogel-based constructs that mimic the 3D structure of tissues such as breast cancer.</p>
                  </li>
                  <li>
                    <p class="no-margin">Manufactured lab-on-a-chip devices for tissue engineering and drug screening. Contributed to more than 5 publications.</p>
                  </li>
                </ul>
              </v-col> 
            </v-row>

            <div>
              <v-divider/>
            </div>

            <!-- INDUSTRY -->
            <v-row class='margin black-text cv' >
              <v-col cols="12" sm='2'>
                <h2 class="titlee">Industry</h2>                
              </v-col>
              <v-col class="cv-text middle" cols="12" sm="10">   
                <h3 class='semi-title '>DuckT &mdash; Co-founder and Software Engineer</h3>
                <i>Nov 2017 &ndash; May 2018, Mexico City</i>
                <ul style="background:#dedede">
                  <li>
                    <p class="no-margin">Partnered with a digital marketing firm to develop digital business strategies and deliver software solutions to their clients.</p>
                  </li>
                  <li>
                    <p class="no-margin">Developed the first pilot version of an online insurance purchasing platform in Mexico in partnership with an insurance brokerage, enhancing user experience and increasing operational efficiency by 70%.</p>
                  </li>
                </ul>
              </v-col>  
            </v-row>

            <v-row class='margin black-text cv' >
              <v-col cols="12" sm='2'>
                <h2 class="titlee"></h2>
              </v-col>
              <v-col class="cv-text middle" cols="12" sm="10">
                <h3 class='semi-title '>IBM &mdash; Software Engineering Intern</h3>
                <i>Jan 2017 &ndash; Jun 2017, Mexico City</i>
                <ul style="background:#dedede">
                  <li>
                    <p class="no-margin">Implemented new features using JavaScript and Apache Cordova, such as enabling and managing e-signatures on the company's web platform and mobile application.</p>
                  </li>
                </ul>
              </v-col>
            </v-row>

            <div>
              <v-divider/>
            </div>

            <!-- SELECTED PUBLICATIONS -->
            <v-row class='margin black-text cv' >
              <v-col cols="12" sm='2'>
                <h2 class="titlee">Selected Publications</h2>                
              </v-col>
              <v-col class="cv-text middle" cols="12" sm="10">   
                <ul style="background:#dedede">
                  <li>
                    <p class="no-margin"><b>Mille L.S.</b> et al. Efficient generation of epitope-targeted de novo antibodies with <a rel="noopener noreferrer" class="link" target="_blank" href="https://github.com/SantiagoMille/germinal">Germinal</a>. <i>bioRxiv</i>, 2025.</p>
                  </li>
                  <li>
                    <p class="no-margin">Lu W.S., Zhang X., <b>Mille L.S.</b>, et al. ProVADA: Generation of Subcellular Protein Variants via Ensemble-Guided Test-Time Steering. <i>bioRxiv</i>, 2025.</p>
                  </li>
                  <li>
                    <p class="no-margin">Zhang X. &amp; <b>Mille L.S.</b> et al. Post-Transcriptional Modular Synthetic Receptors. <i>Nature Chemical Biology</i>, in press.</p>
                  </li>
                  <li>
                    <p class="no-margin">Wang M, Li W, <b>Mille L.S.</b>, et al. Digital Light Processing-based Bioprinting with Composable Gradients. <i>Advanced Materials</i>, 2021.</p>
                  </li>
                  <li>
                    <p class="no-margin">Li W, Wang M, <b>Mille L.S.</b>, et al. A Smartphone-Enabled Portable Digital Light Processing 3D Printer. <i>Advanced Materials</i>, 2021.</p>
                  </li>
                </ul>
              </v-col> 
            </v-row>

            <div>
              <v-divider/>
            </div>

            <!-- FELLOWSHIPS -->
            <v-row class='margin black-text cv' >
              <v-col cols="12" sm='2'>
                <h2 class="titlee">Fellowships</h2>                
              </v-col>
              <v-col class="cv-text middle" cols="12" sm="10">   
                <ul style="background:#dedede">
                  <li>
                    <p class="no-margin"><b>Emerson Collective Scholars Fellow</b> &mdash; Sept 2025 &ndash; Jun 2026</p>
                  </li>
                  <li>
                    <p class="no-margin"><b>Stanford Bio-X SIGF Fellow</b> &mdash; 3 Year Interdisciplinary Graduate Research Fellowship &mdash; Sept 2024 &ndash; May 2027</p>
                  </li>
                  <li>
                    <p class="no-margin"><b>Stanford Graduate Fellow</b> &mdash; 3 Year Graduate Research Fellowship &mdash; Sept 2021 &ndash; May 2024</p>
                  </li>
                  <li>
                    <p class="no-margin"><b>Stanford ChEM-H Chemistry/Biology Interface Trainee</b> &mdash; Sept 2021 &ndash; Aug 2026</p>
                  </li>
                </ul>
              </v-col> 
            </v-row>

            <div>
              <v-divider/>
            </div>

            <!-- INVOLVEMENT -->
            <v-row class='margin black-text cv' >
              <v-col cols="12" sm='2'>
                <h2 class="titlee">Involvement</h2>                
              </v-col>
              <v-col class="cv-text middle" cols="12" sm="10">   
                <h3 class='semi-title '>Stanford Synthetic Biology &mdash; Co-founder and Student Lead</h3>
                <i>Mar 2023 &ndash; Current &bull; <a class='link' href='https://sb.stanford.edu' target='_blank'>sb.stanford.edu</a></i>
                <ul style="background:#dedede">
                  <li>
                    <p class="no-margin">Oversaw the organization of university-wide events (100+ attendees), including symposiums and seminar talks focused on synthetic biology. Coordinated with invited speakers from industry and academia.</p>
                  </li>
                </ul>
              </v-col> 
            </v-row>

            <v-row class='margin black-text cv' >
              <v-col cols="12" sm='2'>
                <h2 class="titlee"></h2>                
              </v-col>
              <v-col class="cv-text middle" cols="12" sm="10">   
                <h3 class='semi-title '>Stanford ChEM-H Postbaccalaureate Program &mdash; Mentor</h3>
                <i>Sept 2023 &ndash; Current</i>
                <ul style="background:#dedede">
                  <li>
                    <p class="no-margin">Trained a mentee on fundamental molecular biology techniques and supervised the design and execution of diverse experiments in mammalian cells, while supporting their professional and personal growth.</p>
                  </li>
                </ul>
              </v-col> 
            </v-row>

            <div>
              <v-divider/>
            </div>

          </v-container>

          <div class="py-12"></div>
        </section>
      </v-content>

      <v-footer
        class="justify-center"
        color="#4C6665"
        height="100"
      >
        <div class="title font-weight-light grey--text text--lighten-1 text-center">
          &copy; {{ (new Date()).getFullYear() }} — Made with 💜 by Santiago Mille
        </div>
      </v-footer>
    </v-app>
  </div>
</template>

<script>
  export default {
    name: 'HomePage',

    data: () => ({
      text: 'am a scientist',
      hobbiesList: ['am a scientist','design proteins','am a synthetic biologist','am an engineer','enjoy brewing things', 'build things', 'am Mexican'],
      colorList: ['H04F06A','HFF5D73','HFFA69E','H2DE1FC','HFF7E6B', 'Hffd33c'],
      continue:true,
      color:'#04F06A',
      hobbiesListIter: 0,
      drawer:false
    
    }),
    mounted(){
      this.repeatTimeout(0);
    },
    methods:{
      repeatTimeout(prevN) {
        let num = Math.round(Math.random() * 5)
        while(prevN===num){
          num = Math.round(Math.random() * 5)
        }
        
        setTimeout(function(){
          if(this.continue){
            this.text = this.hobbiesList[this.hobbiesListIter]
            this.hobbiesListIter = (this.hobbiesListIter+1)%this.hobbiesList.length
            this.color = this.colorList[num]
            this.repeatTimeout(num)
          }
        }.bind(this),1500);
      }
    }
  }
</script>
<style scoped>
.color{
  background: #4C6665;
  min-width: 100vw;
  min-height: 130vh;
}
.H04F06A{
  color: #04F06A;
}
.HFF5D73{
  color: #FF5D73;
}

.HFFA69E{
  color: #D4C5E2;
}

.H2DE1FC{
  color: #2DE1FC;
}

.HFF7E6B{
  color: #FF7E6B;
}

.Hffd33c{
  color: #ffd33c;
}

.padding-top{
  padding-top: 100px;
  padding-bottom: 0;
  margin-bottom: -5rem; 
}

.margin-top{
  margin-top: 3rem;
}

.v-list-item{
  min-height: fit-content !important;
}

.no-margin{
  margin-bottom: 2px;
}

.aboutMe{
  align-content: center;
  text-align: justify !important;
  font-weight: 200;
  font-size: clamp(14px, 2vmin, 18px);
}

.aboutMe_intro{
  align-content: center;
  text-align: justify !important;
  font-weight: 300;
  font-size: clamp(16px, 2.2vmin, 20px);
}

.download-resume{
  text-decoration-line: underline;
  color: #FF5D73;
  text-align: end;
}

.bottom{
  position:absolute;                  
  bottom:0;
}

.semi-title{
  margin-top: 5px;
  margin-left: 1px;
}

.img{
  max-width: 85%;
  max-height: 425px;
  margin: auto;
  border-radius: 30px;
}

.black-text{
  color: #464655;
}

.less-margin{
  margin: auto;
}

.link{
  text-decoration: none;
  color: #FF5D73;
  text-decoration-line: none;
}

.link_title{
  text-decoration: none;
  color: #464655 ;
  text-decoration-line: none;
}

.link-r{
  
  color: #464655;
}

.margin{
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
}

.margin-about{
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.cv{
  text-align: justify;
}

@media only screen and (max-width: 800px) {
  .semi-title {
    margin-top: 3px;
    margin-left: 1px;
    font-size: 2.2vmax;
  }
  .cv-text{
    font-size: 2.2vmax;
  }
  .middle{
    padding-left: 10px;
  }
  .titlee{
    font-size: 2.5vmax;
  }
  .aboutMe{
    font-size: 15px;
  }
  .aboutMe_intro{
    font-size: 17px;
  }
}

</style>
